import {effect} from '@angular/core';
import {getState, patchState, signalStoreFeature, withHooks, withMethods} from '@ngrx/signals';
import {MainInjector, SignalStoreNames} from '@shared-types';

import {IndexedDbSyncService} from '../../services';

export function withIdbPersistence<T extends object>(indexedDbKey: SignalStoreNames, initialState: T) {
	return signalStoreFeature(
		// Methods
		withMethods(store => {
			const indexedDbSyncService = IndexedDbSyncService.getInstance();
			return {
				// Load state from indexedDb
				loadState: async () => {
					const state = (await indexedDbSyncService.loadState<T>(indexedDbKey)) || initialState;
					if (state) {
						patchState(store, state);
					}
				},
				// Save state to indexedDb
				saveState: async (state: any) => {
					await indexedDbSyncService.saveState(indexedDbKey, state);
					// @ts-ignore
					patchState(window.APP_INDEXED_DB, {[indexedDbKey]: state});
				},

				// reset state to initial state
				resetState: async () => {
					patchState(store, initialState);
					window.alert('resetState');
					await indexedDbSyncService.clearState(indexedDbKey);
				},
			};
		}),
		// Hooks:
		withHooks({
			onInit(store) {
				store.loadState().then(() => {
					effect(
						() => {
							const state = getState(store);
							if (state) store.saveState(state);
						},
						{
							injector: MainInjector,
						},
					);
				});
			},
			onDestroy(store) {},
		}),
	);
}
